module.exports = __webpack_public_path__ + "img/cz-tags.5c98ed41.svg";